/**
 * Состояние свёртки — ЛОКАЛЬНОЕ, в localStorage, а не в базе.
 *
 * Свёртку щёлкают десятки раз в минуту; гонять это в БД жалко, а колонки `collapsed`
 * в схеме нет и не будет. Цена решения записана прямо: свёртка не переезжает между
 * устройствами (ui-spec Область 2).
 */

const KEY = "mapcraft:collapsed";

function read(): Set<string> {
	try {
		const raw = localStorage.getItem(KEY);
		return new Set(raw ? (JSON.parse(raw) as string[]) : []);
	} catch {
		return new Set();
	}
}

function write(set: ReadonlySet<string>): void {
	try {
		localStorage.setItem(KEY, JSON.stringify([...set]));
	} catch {
		// Приватный режим: свёртка просто не переживёт перезагрузку. Это не повод падать.
	}
}

export class CollapseStore {
	private set = read();
	private listeners = new Set<() => void>();
	private snapshot: ReadonlySet<string> = this.set;

	subscribe = (listener: () => void): (() => void) => {
		this.listeners.add(listener);
		return () => this.listeners.delete(listener);
	};

	getSnapshot = (): ReadonlySet<string> => this.snapshot;

	isCollapsed = (key: string): boolean => this.snapshot.has(key);

	toggle(key: string): void {
		const next = new Set(this.set);
		if (next.has(key)) {
			next.delete(key);
		} else {
			next.add(key);
		}
		this.commit(next);
	}

	set_(key: string, collapsed: boolean): void {
		const next = new Set(this.set);
		if (collapsed) {
			next.add(key);
		} else {
			next.delete(key);
		}
		this.commit(next);
	}

	/** `ec0…ec9`: свернуть всё глубже уровня N. Обход ограничен уровнем — не «развернуть всё». */
	collapseToLevel(keys: readonly { key: string; depth: number }[], level: number): void {
		const next = new Set(this.set);
		for (const row of keys) {
			if (row.depth >= level) {
				next.add(row.key);
			} else {
				next.delete(row.key);
			}
		}
		this.commit(next);
	}

	private commit(next: Set<string>): void {
		this.set = next;
		this.snapshot = next;
		write(next);
		for (const listener of this.listeners) {
			listener();
		}
	}
}

export const collapseStore = new CollapseStore();
